import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  gradient?: boolean;
}

export const Card: React.FC<CardProps> = ({ children, className = '' }) => {
  const baseClasses = 'rounded-2xl p-6 shadow-lg transition-shadow duration-300 hover:shadow-xl';
  const bgClasses = 'bg-white';

  return (
    <div className={`${baseClasses} ${bgClasses} ${className}`}>
      {children}
    </div>
  );
};
